const initialState = {
  brokers: { data: { data: [], pagination: {} } },
  broker: { data: null }
};

const brokerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_BROKERS':
      return {
        ...state,
        brokers: { data: action.data.data } // Only store the inner data object
      };
    case 'GET_BROKER_BY_ID':
      return {
        ...state,
        broker: {  data: action.data.data}
      };
    default:
      return state;
  }
};

export default brokerReducer;
